import React from 'react'
import {observer} from 'mobx-react-lite'
import get from 'lodash/get'
import { useStore } from '../../../../hooks/useStore'
import { GridItem } from '../griditem'
const WidgetCaptcha = observer((props) =>  {
    const {uiStore} = useStore()
    return (
        <GridItem {...props}>

            <div className="captcha">
                <CaptchaHeader/>
                <CaptchaGrid/>
                <CaptchaFooter/>
                <BackgroundAudio uiStore={uiStore}/>
            </div>
        </GridItem>
    )
})

const CaptchaHeader = observer((props) => { 
    const {uiStore: {home__captchaError}} = useStore();


    return (
        <div className={`captcha__header ${home__captchaError ? "captcha__header--error" : ""}`}>
            <h4 className="captcha__header__sub text-s">Select all images that contain</h4>
            <h3 className="captcha__header__main">School</h3>

            <style jsx>{`
                .captcha__header, .captcha__footer {
                    background: #648FE0;
                    height: 92px;
                    padding: 20px;
                }

                .captcha__header__main {
                    font-size: 24px;
                    margin-top: 6px;
                }

                h3,h4 {
                    color: #fff;
                }

                

                .captcha__header--error {
                    animation: error .65s cubic-bezier(0.165, 0.84, 0.44, 1);
                    animation-fill-mode: forwards;
                }

                @keyframes error {
                    from {
                        background: #b00020;
                    }

                    to {
                        background: #648FE0;
                    }
                }
            `}</style>
        </div>
    )
})

const CaptchaFooter = (props) => {
	return (
		<div className="captcha__footer">
			<img className="captcha__logo"src="/images/logo.svg" alt=""/>
			<MuteButton/>

			<VerifyButton/>

            <style jsx>{`

                .captcha__footer {
                    background: white;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 53px;
                    padding: 10px;
                    border-top: 1px solid #dadada;
                }
            `}</style>
		</div>
	)
}



const VerifyButton = () =>  {
    const {uiStore: {verifyCaptcha}} = useStore()
    const reachedLimit = false;
    return <div
        // onTouchStart={reachedLimit ? null : this._handleTouchStart} 
        // onTouchEnd={reachedLimit ? null : this._handleTouchEnd} 
        // onMouseDown={reachedLimit ? null : this._handleTouchStart}
        // onMouseUp={reachedLimit ? null : this._handleTouchEnd}
        onClick={verifyCaptcha}
        className={`captcha__footer__button helvetica ${false ? "captcha__footer__button--touched" : ""} ${reachedLimit ? "captcha__footer__button--disabled" : " "}`}>
            Verify

            <style jsx>{`
            
                .captcha__footer__button {
                    display: inline-block;
                    background: #648FE0;
                    outline: none !important;
                    border:none;
                    border-radius: 2px;
                    color: #fff;
                    padding: 8px 28px;
                    font-size: 14px;
                    font-weight: bold;
                    text-transform: uppercase;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
                    transition: all .08s ease-in-out;
                    cursor: pointer;
                }

                .captcha__footer__button--disabled {
                    background: #aaa;
                    box-shadow: none;
                    cursor: default;
                }


                .captcha__footer__button--touched {
                    // 648FE0
                    background: #577DC2;
                }

            `}</style>
        </div>
}

const CaptchaGrid = () =>  {

    const test = new Array(6).fill().map((item, idx) => {
        return <RecaptchaItem key={`cpt-${idx}`}  idx={idx} />
    })

    return(
        <div className="captcha__captcha-grid">
            {test}

            <style jsx>{`
                .captcha__captcha-grid {
                    display: grid;
                    padding: 2px 2px;
                    grid-gap: 2px;
                    grid-template-rows: 1fr 1fr 1fr;
                    grid-template-columns: 1fr 1fr;
                    height: 320px;
                }
            `}</style>
        </div>
    )
}

// @inject("store") @observer
const RecaptchaItem = observer((props) => {
	// constructor(props) {
	// 	super(props);

	// 	this.state = {
	// 		active: false
	// 	}
	// }

	// _toggleImage = () => {
	// 	// this.props.store.toggleCaptchaImage(this.props.idx);

	// 	this.setState({
	// 		// active: !this.state.active,
	// 		touch: false
	// 	})
	// }

	// _handleTouchStart = () => {
	// 	this.setState({
	// 		touch: true
	// 	})
	// }

	// _handleTouchEnd = () => {
	// 	this.setState({
	// 		touch: false
	// 	})
	// }

    const {uiStore: {home__captchaImages, home__captchaReady, toggleCaptchaImage}} = useStore();
    if (!home__captchaReady) return null
    const {idx} = props;
    const {atEndOfCaptcha} = props;
    const captchaImage = home__captchaImages[idx];
    if (!captchaImage) return null
    
    const src = get(captchaImage, `image.fields.image.fields.file.url`, "");

    const fm = true ? "webp" : "jpg"; // is chrome??
    const formattedSrc = `${src}?w=300&fm=${fm}&q=95`;


    return (
        <div className={`rc-item ${captchaImage.active ? "rc-item--active" : ""}`}>
            {captchaImage.active ? <Check/>: null}

            <CaptchaImage 
                src={formattedSrc}
                onClick={atEndOfCaptcha ? null : () => toggleCaptchaImage(idx)} 
                // onTouchStart={atEndOfCaptcha ? null : this._handleTouchStart}
                // onTouchEnd={atEndOfCaptcha ? null : this._handleTouchEnd}
            />
            <style jsx>{`
                .rc-item {
                    transition: transform .4s cubic-bezier(0.19, 1, 0.22, 1), opacity .15s ease-out;
                    position: relative;
                    transform: translate3d(0,0,0);
                    transition-delay: .05s;
                }
                
                
                .rc-item--active {
                    transform: translate3d(0,0,0) scale(.8)
                }
                
                .rc-item__check {
                    width: 28px;
                    position: absolute;
                    z-index: 10;
                    top: -14px;
                    left: -14px;
                }
            `}</style>
        </div>
    )
	
})

const CaptchaImage = (props) => {
	const style = {
		backgroundImage: `url('${props.src}')`,
		backgroundSize: "cover",
		width: "100%",
		height: "100%"
	}
	return <div style={style} className="map-image" onClick={props.onClick} >

        <style jsx>{`
            .map-image {
                width: 100%;
                height: 100%;
                background: #fafafa;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
                cursor: pointer;
            }
        `}</style>
    </div>
}

const Check = React.memo(() => {
	return(
		<svg className="rc-item__check" viewBox="0 0 47 47">
			<defs>
				<style>{".cls-1{isolation:isolate;}.cls-2{opacity:0.4;mix-blend-mode:multiply;}.cls-3{fill:#407cfb;}.cls-4{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:3.5px;}"}</style>
			</defs>
			<g className="cls-1">

						<image className="cls-2" width="47" height="47" href="data:image/png;base64,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"/>
						<circle className="cls-3" cx="22.75" cy="21.38" r="17"/>
						<polyline className="cls-4" points="12.25 20.63 19.75 28.13 33.25 14.63"/>
				
			</g>

            <style jsx>{`
                .rc-item__check {
                    width: 28px;
                    position: absolute;
                    z-index: 10;
                    top: -14px;
                    left: -14px;
                } 
            `}</style>
		</svg>
	)
});


class BackgroundAudio extends React.Component {

    state = {
        muted: false
    }

	componentDidMount() {
		// this.props.store.registerBackgroundAudio(this)
		// this.audio.volume = .68;
        this.props.uiStore.registerBackgroundAudio(this)
	}

	_handleLoad = () => {
		if (this.loaded) return 
		this.loaded = true;
		this.props.store.handleBackgroundLoad() 
		// const {audio} = this.refs;
	}

	play = () => {
		// const {audio} = this.refs;
        const audio = this.audio;
		audio.load()
		audio.play()
	}

    mute = () => {
        this.setState({
            muted: true
        })
    }

    unmute = () => {
        this.setState({
            muted: false
        })
    }


	render() {
        const muted = false;

		return (
			<audio ref={el => this.audio = el} volume={.4} muted={this.state.muted ? true : null} preload="auto" loop >
				<source src={"assets/audio/brbCon_envelope.mp3"} type="audio/mp3"/>
			</audio>
		)
	}
}

const MuteButton = observer(() =>  {
    const {uiStore: {home__audioMuted, toggleMute}} = useStore();

    // sound-icon--hidden
    return(
        <svg className={`sound-icon ${home__audioMuted ? "sound-icon--inactive" : ""} `} viewBox="0 0 16 12" onClick={toggleMute}>
            <defs>
                <polygon id="path-1" points="0 11.6102182 15.9542857 11.6102182 15.9542857 -0.000327272727 0 -0.000327272727"></polygon>
            </defs>
            <g id="Symbols" stroke="none" strokeWidth=".5" fill="#aaa" fillRule="evenodd">
                <g id="Desktop-Header" transform="translate(-281.000000, -20.000000)">
                    <g id="sound" transform="translate(281.000000, 20.000000)">
                        <g id="Page-1">
                            <path className="sound-icon__body" d="M6.76537143,10.8706909 L3.44994286,8.10632727 C3.30022857,7.98196364 3.1208,7.91432727 2.93565714,7.91432727 L1.45222857,7.91432727 C0.965371429,7.91432727 0.571085714,7.45723636 0.571085714,6.89323636 L0.571085714,4.69723636 C0.571085714,4.13214545 0.965371429,3.67505455 1.45222857,3.67505455 L3.01794286,3.67505455 C3.20537143,3.67505455 3.38708571,3.60632727 3.53794286,3.47869091 L6.75965714,0.744872727 C7.34137143,0.250690909 8.15965714,0.732872727 8.15965714,1.5696 L8.15965714,10.0416 C8.15965714,10.8739636 7.34822857,11.3561455 6.76537143,10.8706909 Z" id="Stroke-1" stroke=""></path>
                            
                            <path className="sound-icon__p1" d="M11.2392,8.40861818 C12.7512,6.96534545 12.7512,4.62425455 11.2392,3.17989091" id="Stroke-3" stroke="#aaa" strokeLinecap="round"></path>
                            <path className="sound-icon__p2" d="M13.2380571,10.7364 C16.0974857,8.00694545 16.0974857,3.58221818 13.2380571,0.852763636" id="Stroke-5" stroke="#aaa" strokeLinecap="round"></path>

                                
                            <mask id="mask-2" fill="white">
                            </mask>
                            <g id="Clip-8"></g>
                        </g>
                    </g>
                </g>
            </g>

            <style jsx>{`
                .sound-icon {
                    right: 124px;
                    position: absolute;
                    width: 18px;
                }
                
                .sound-icon {
                
                    cursor: pointer;
                

                }

                .sound-icon__p1 {
                    transition-delay: .14s;
                }
            
                .sound-icon__p2 {
                    transition-delay: .28s;
                }
                
                .sound-icon__body {
                    transition: opacity .35s ease-in-out;
                }
                
                .sound-icon__p1, .sound-icon__p2 {
                    transition: opacity .35s ease-in-out;
                }
                
                .sound-icon--inactive {
                    cursor: pointer;
                }

                .sound-icon--inactive .sound-icon__body {
                    opacity: .65;
                    transition-delay: .28s;
                }
            
                .sound-icon--inactive .sound-icon__p1 {
                    opacity: 0;
                    transition-delay: .14s;
                }
            
                .sound-icon--inactive .sound-icon__p2 {
                    opacity: 0;
                }
                
                .sound-icon--hidden {
                    pointer-events: none;
                }

                .sound-icon--hidden *{
                    opacity: 0;
                }
            
            `}</style>
        </svg>
    )
})


export default WidgetCaptcha